<template>
  <div class="default:relative">
    <template v-if="isAnimationVisible">
      <div
        ref="longBar"
        class="bar bar_long"
      ></div>
      <div
        ref="shortBar"
        class="bar bar_short"
      ></div>
    </template>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    loading?: boolean
  }>(),
  {
    loading: false,
  }
)

const isAnimationVisible = ref(props.loading)
watchEffect(() => {
  if (props.loading) {
    isAnimationVisible.value = true
  }
})

const animationDuration = 2600
const animationFinalKeyframe = 0.6
const longBar = ref<HTMLDivElement>()
useEventListener(longBar, ["animationstart", "animationiteration"], () => {
  setTimeout(() => {
    if (!props.loading) {
      isAnimationVisible.value = false
    }
  }, animationDuration * animationFinalKeyframe)
})
</script>

<style lang="scss" scoped>
.bar {
  @apply absolute inset-0 h-full origin-top-left bg-blue-700/70 dark:bg-blue-800;

  &_long {
    animation: progress calc(v-bind(animationDuration) * 1ms) cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
  }

  &_short {
    transform: translate3d(-101%, 0, 0) scaleZ(1);
    animation: progress-short calc(v-bind(animationDuration) * 1ms) cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
    animation-delay: 1.65s;
  }
}

@keyframes progress {
  0% {
    transform: translate3d(-35%, 0, 0) scale3d(0.35, 1, 1);
  }

  60% {
    transform: translate3d(100%, 0, 0) scale3d(0.9, 1, 1);
  }

  to {
    transform: translate3d(100%, 0, 0) scale3d(0.9, 1, 1);
  }
}

@keyframes progress-short {
  0% {
    transform: translate3d(-101%, 0, 0) scaleZ(1);
  }

  60% {
    transform: translate3d(107%, 0, 0) scale3d(0.01, 1, 1);
  }

  to {
    transform: translate3d(107%, 0, 0) scale3d(0.01, 1, 1);
  }
}
</style>
